import { defineStore } from 'pinia';
import { useHelpTool, useCacheData } from '@/hooks';
import { queryGamePlatform, queryGameHot, queryGameLike, collectGame, cancelCollectGame } from '@/api';

const { checkUserLogin } = useHelpTool();
const { localCache } = useCacheData();

const MENU_SETTING = {
  default: { showProvider: true, showType: 0, background: { r: 250, g: 255, b: 0 } },
  hot: { showProvider: false, showType: 0, background: { r: 250, g: 255, b: 0 } },
  favorite: { showProvider: false, showType: 0, background: { r: 250, g: 255, b: 0 } },
  slot: { showProvider: true, showType: 0, background: { r: 0, g: 148, b: 255 } },
  live: { showProvider: true, showType: 1, background: { r: 250, g: 0, b: 255 } },
  sports: { showProvider: false, showType: 2, background: { r: 0, g: 240, b: 255 } },
  fish: { showProvider: true, showType: 0, background: { r: 0, g: 255, b: 56 } },
  poker: { showProvider: true, showType: 0, background: { r: 250, g: 0, b: 0 } },
  arcade: { showProvider: true, showType: 0, background: { r: 255, g: 255, b: 255 } },
};

export const useGameStore = defineStore('game', {
  state: () => {
    return {
      gameMenu: [], //游戏类型列表
      activeGameMenu: null, //当前选中的游戏类型
      hotGameList: [],
      providerList: [],
      likeGameMap: {}
    }
  },
  getters: {},
  actions: {
    set(key, value = 0) {
      this[key] = value;
    },
    initMenu() {
      return localCache({
        cacheKey: 'gameMenu',
        defaultData: [],
        dataApi: queryGamePlatform, 
        formatData: data => {
          let _menuList = data;
          _menuList = _menuList.map(menu => {
            let code = menu.code
            let setting = MENU_SETTING[code] || MENU_SETTING.default
            let providerList = menu.manufs || [];
            if (code !== 'hot' && code !== 'favorite') {
              providerList.unshift({ code: 'HOT', name: 'HOT' });
            }
            return {
              ...menu,
              ...setting,
              providerList
            }
          })
          return _menuList;
        },
        dataProcessing: data => {
          this.gameMenu = data;
          this.activeGameMenu = this.gameMenu[0] || {};
          this.providerList = this.activeGameMenu.providerList || [];
        }
      })
    },
    initHotGame() {
      return localCache({
        cacheKey: 'hotGameList',
        defaultData: [],
        dataApi: queryGameHot,
        dataProcessing: data => {
          this.hotGameList = data;
        }
      })
    },
    fetchHotGameList({ pageSize, current }) {
      let gameList = this.hotGameList;
      if (this.activeGameMenu.code != 'hot') {
        gameList = this.hotGameList.filter(item => item.type === this.activeGameMenu.code);
      }
      return {
        data: gameList.slice((current - 1) * pageSize, current * pageSize),
        page: current,
        total: gameList.length
      };
    },
    fetchGameLikeMap() {
      // 增加 retrun 为了在main.js中可以使用 Promise.all 等待请求完成
      return queryGameLike({}).then(res => {
        this.likeGameMap = res.data || [];
      })
    },
    changeMenu(item) {
      let targetMenu;
      if (typeof item === 'string') {
        this.gameMenu.map(menu => {
          if (menu.code === item) {
            targetMenu = menu;
          }
        })
        // 如果没有选中任何游戏类型 设置默认类型
        if (!targetMenu) {
          targetMenu = this.gameMenu[0];
        }
      } else {
        targetMenu = item;
      }
      if (targetMenu.code === 'favorite') {
        checkUserLogin(() => {
          this.activeGameMenu = targetMenu;
          this.providerList = targetMenu?.providerList || [];
        });
      } else {
        this.activeGameMenu = targetMenu;
        this.providerList = targetMenu?.providerList || [];
      }
    },
    getMenuSetting() {
      return MENU_SETTING
    },
    toggleLikeGame(gid) {
      if (this.likeGameMap[gid]) {
        cancelCollectGame({ gid }).then(res => {
          delete this.likeGameMap[gid];
        })
      } else {
        collectGame({ gid }).then(res => {
          this.likeGameMap[gid] = true;
        })
        
      }
    }
  }
})
